var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-header-frill-launcher"},[_c('i',{staticClass:"ddi ddi-megaphone marker--app-header--frill-announcements-btn",attrs:{"icon":"megaphone"}}),_c('frill-widget')],1)}
var staticRenderFns = []

export { render, staticRenderFns }